// extracted by mini-css-extract-plugin
export default {"wrap":"initLoader_wrap__PYQiO","texts":"initLoader_texts__WS2Pq","moveText":"initLoader_moveText__BJRfG"};